<template>
  <div>
    <v-notification>
    </v-notification>
    <div class="activation-history__title">
      <img src="/img/svg/common/document-check.svg" alt=""/>
      <h1>{{ getLocalization('Phone history activations') }}</h1>
    </div>
    <div class="phones-mails mb-2">
      <div class="one active badge-container">{{ getLocalization('Phone history cabinet') }}
        <div v-if="waitingForSmsCount > 0" class="badge badge-pa">{{waitingForSmsCount}}</div>
      </div>
      <div class="one badge-container" @click="selectMails">{{ getLocalization('Mail history') }}
        <div v-if="waitingForCodeMails > 0" class="badge badge-pa">{{waitingForCodeMails}}</div>
      </div>
    </div>
    <div class="activation-history__tags">
      <div class="tags justify-content-between">
        <div v-for="filter in filters" :key="filter.id"
             @click="filterPhoneActivations(filter.id)"
             :class="['tag-item', filter.isActive ? 'active' : '']"
        >{{ getLocalization(filter.label) }}
        </div>
      </div>
    </div>
    <div v-if="allPhoneFilterActive" class="--all">
      <div class="activation-history-all">
        <div class="activation-history-all__mobile-content">
          <div
              id="activation-history-all-filter"
              class="activation-history-all__filter show"
          >
            <base-table
                :columns="this.columns"
                table-class="vgt-table activation-history-all__table new-design-table"
                :render-list-to-show="this.listToShow"
                :wrapperFiltersData="this.wrapperFiltersData"
                :use-green-pagination="true"
                :per-page-default="perPage"
                :dynamic-sort="true"
                :table-title="null"
                :accept-filters-button-label="getLocalization('Apply filters')"
                :download-csv-text="getLocalization('Download CSV')"
                :enable-save-csv="true"
                csv-filename="phoneActivationList"
                save-csv-url="/cabinet/client/phonehistory/downloadCsvFile"
                new-design-class="activation-history-partner__body"
            >
              <template v-slot:base-table-row="props">
                <td v-if="props.column.field === 'phone'">
                  +{{ props.formattedRow[props.column.field] }}
                </td>
                <td v-else-if="props.column.field === 'sms'">
                  <div v-for="code in props.formattedRow[props.column.field]?.split(',')">
                    {{ code }}
                  </div>
                </td>
                <td v-else-if="props.column.field === 'country'">
                  {{ getLocalization(props.formattedRow[props.column.field]) }}
                </td>
                <td v-else-if="props.column.field === 'price'">
                  {{ props.formattedRow[props.column.field] }}₽
                </td>
                <td v-else-if="props.column.field === 'status'">
                  {{ getLocalization(props.formattedRow[props.column.field]) }}
                </td>
                <template v-else>
                  <td>{{ props.formattedRow[props.column.field] }}</td>
                </template>
              </template>
              <template v-slot:base-table-pagination-green="props">
                <div class="activation-history-all__pagination">
                  <green-custom-pagination
                      :total="phoneActivationsData.length"
                      :perPage="perPage"
                      :pageChanged="props.pageChangedCustom"

                  ></green-custom-pagination>
                </div>
              </template>
            </base-table>
          </div>
        </div>
        <div class="activation-history-all__items">
          <div class="activation-history-all-card" v-for="phoneActivation in phoneActivationsData">
            <div class="--item --row --flex-1">
              <div class="--label">{{ getLocalization('Date') }}</div>
              <div class="--value">{{ phoneActivation['date'] }}</div>
            </div>
            <div class="--divider"></div>
            <div class="--item">
              <div class="--label">{{ getLocalization('Country') }}</div>
              <div class="--value">{{ phoneActivation['country'] }}</div>
            </div>
            <div class="--item">
              <div class="--label">{{ getLocalization('Service') }}</div>
              <div class="--value">{{ phoneActivation['service'] }}</div>
            </div>
            <div class="--divider"></div>
            <div class="--item">
              <div class="--label">{{ getLocalization('Status') }}</div>
              <div class="--value">{{ phoneActivation['status'] }}</div>
            </div>
            <div class="--item">
              <div class="--label">{{ getLocalization('Number') }}</div>
              <div class="--value">+{{ phoneActivation['phone'] }}</div>
            </div>
            <div class="--item">
              <div class="--label">{{ getLocalization('Price') }}</div>
              <div class="--value">{{ phoneActivation['price'] }} ₽</div>
            </div>
            <div class="--divider"></div>
            <div class="--item">
              <div class="--label">{{ getLocalization('Sms') }}</div>
              <div class="--value">
                <div v-for="code in phoneActivation.sms?.split(',')">
                  {{ code }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="--waiting">
      <div class="activation-history__info-message">
        <div>
          {{ getLocalization('Waiting for SMS') }} {{ waitingForSmsCount }} {{ getLocalization('pcs') }} / {{ getLocalization('locked') }} {{ lockedForWaiting }}₽
        </div>
      </div>
      <div class="activation-history__list-items">

        <div v-for="(phoneActivation,key) in phoneActivationsData"
             :class="'activation-history-card' + (phoneActivation.status.id === STATUS_CANCEL ? ' canceled' : '')"
        >
          <div class="activation-history-card__main">
            <div class="--left">
              <div class="--service">
                <img :src="phoneActivation.service_variation.service.img_path" alt="">
                <span>{{ phoneActivation.service_variation.service.title }}</span>
              </div>
              <div class="--country">
                <img :src="phoneActivation.service_variation.country.img_path" alt="">
                <span>+{{ phoneActivation.phone }}</span>
                <div class="--copy js-copy copy-wrapper" @click="copyText(phoneActivation.phone, $event)">
                  <img src="/img/svg/common/copy.svg" alt=""/>
                  <div class="custom-notification">
                    <div class="notification-title">{{getLocalization('Copied')}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="--center">
              <div :class="'--status' + (phoneActivation.sms_code == null && phoneActivation.status.id != STATUS_CANCEL ? '' : ' --full')">
                <div class="--label">{{ getLocalization('Status') }}</div>
                <div v-if="phoneActivation.status.id === STATUS_WAIT_ACCEPTING" class="--value">{{ getLocalization('SMS was received') }}</div>
                <div v-else>{{ getLocalization(phoneActivation.status.description) }}</div>
              </div>
              <div v-if="(phoneActivation.sms_code == null && phoneActivation.status.id != STATUS_CANCEL)" class="--time">
                <div class="--label">{{ getLocalization('Time') }}</div>
                <div class="--value"
                     v-if="phoneActivation.status.id == STATUS_WAIT_CODE || phoneActivation.status.id == STATUS_WAIT_ACCEPTING || phoneActivation.status.id == STATUS_WAIT_NEXT_SMS">
                  <timer :target-time="phoneActivation.available" :with-hours="false"/>
                </div>
              </div>
              <div class="--price">
                <div class="--label">{{ getLocalization('Price') }}</div>
                <div class="--value">{{ phoneActivation.price }}₽</div>
              </div>
            </div>
            <div class="--right">
              <button class="button primary" v-if="[STATUS_WAIT_CODE].includes(phoneActivation.status.id)"
                      @click="changePhoneActivationStatus(phoneActivation.id, key, STATUS_CANCEL)"
                      :disabled="phoneActivation.disableCancelButton"
              >
                {{ getLocalization('Cancel') }}
              </button>
              <button class="button primary" v-if="[STATUS_WAIT_ACCEPTING, STATUS_WAIT_NEXT_SMS].includes(phoneActivation.status.id)"
                      @click="requestAnotherSms(phoneActivation.id, key)"
                      :disabled="phoneActivation.disableNextSmsButton">
                {{ getLocalization('Another sms') }}
              </button>
              <button class="button orange" v-if="[STATUS_WAIT_ACCEPTING, STATUS_WAIT_NEXT_SMS].includes(phoneActivation.status.id)"
                      @click="changePhoneActivationStatus(phoneActivation.id, key, STATUS_OK)"
                      :disabled="phoneActivation.disableCancelButton">
                {{ getLocalization('Finish activation') }}
              </button>
            </div>
          </div>
          <div class="activation-history-card__other"
               v-if="phoneActivation.status.id == STATUS_WAIT_CODE || phoneActivation.status.id == STATUS_WAIT_ACCEPTING || phoneActivation.status.id == STATUS_WAIT_NEXT_SMS">
            <div class="--codes --multi" v-if="phoneActivation.sms_code?.length > 0">
              <div :data-index="index + 1" v-for="(code, index) in phoneActivation.sms_code?.split(',')" :key="code">
                <span>{{ code }}</span>
                <div class="--copy js-copy copy-wrapper" @click="copyText(code, $event)">
                  <img src="/img/svg/common/copy.svg" alt=""/>
                  <div class="custom-notification">
                    <div class="notification-title">{{getLocalization('Copied')}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="--codes --multi codes-arrow" :class="{ 'justify-content-center': phoneActivation.service_variation.service.id === 5 }">
              <div class="no-content no-content-spinner code-padding"></div>
              <div :data-index="1" class="no-content"></div>
              <vue-spinner class="no-content-spinner" color="#ef8512"></vue-spinner>
              <img class="no-content-spinner arrow-code" src="/img/svg/common/arrow.svg" alt=""/>
              <div class="no-content-spinner code-text">{{getLocalization('Code will be here')}}</div>
            </div>
            <div class="d-flex flex-wrap"></div>
            <div class="row pa-info">
              <div :class="{ 'col-xl-6 col-12': true, 'left-info-margin': phoneActivation.service_variation.service.id !== 5
              && (!phoneActivation.sms_code || phoneActivation.sms_code.length <= 1)}">
                <div class="--left">
                  {{ getLocalization('Average SMS waiting time') }}:
                  {{ Math.floor((phoneActivation.avg_time / 60) % 60) === 0 ? '2' :  Math.floor((phoneActivation.avg_time / 60) % 60)}} {{ getLocalization('min') }}
                  {{ Math.floor(phoneActivation.avg_time % 60) === 0 ? '30' : Math.floor(phoneActivation.avg_time % 60) }} {{ getLocalization('sec') }}
                </div>
                <div class="w-75 mt-3 right --left lift-info">
                  {{ getLocalization('If the SMS code does not received, you can cancel the activation and the money will be returned to your balance') }}
                </div>
                <div class="left-buy-number">
                  <button @click="triggerBuyPhoneNumber(phoneActivation)" class="button primary">{{getLocalization('Buy')}}</button>
                  <div class="arrow-buy-number">
                    <img src="/img/svg/common/arrow-buy-number.svg" alt="">
                  </div>
                  <div class="left-buy-number-text">{{getLocalization('Buy another one number')}}</div>
                </div>
              </div>
              <div class="col-xl-4 col-12 right" v-if="phoneActivation.service_variation.service.id === 5">
                <div v-html="getLocalization('Telegram registration is only possible in the official mobile client on a mobile device. When registering via the web version or unofficial clients, the code will not be received')"></div>
                <div class="mt-2 right mb-pa-card">
                  {{ getLocalization('We also recommend using an IP VPN or Proxy from the country you are trying to purchase from.') }}
                </div>
              </div>
              <div class="col-xl-4 col-12 right mb-pa-card" v-else>
                  {{ getLocalization('We also recommend using an IP VPN or Proxy from the country you are trying to purchase from.') }}
              </div>
              <div class="left-buy-number-mobile">
                <button @click="triggerBuyPhoneNumber(phoneActivation)" class="button primary">{{getLocalization('Buy')}}</button>
                <div class="arrow-buy-number">
                  <img src="/img/svg/common/arrow-buy-number.svg" alt="">
                </div>
                <div class="left-buy-number-text">{{getLocalization('Buy another one number')}}</div>
              </div>
            </div>

          </div>
          <div v-if="phoneActivation.mail_activation" class="mt-3">
            <div class="activation-history-card__main mail-history-card">
              <div class="--left">
                <div class="--service">
                  <img :src="phoneActivation.service_variation.service.img_path" alt="">
                  <span>{{ phoneActivation.service_variation.service.title }}</span>
                </div>
                <div class="--country">
                  <img :src="phoneActivation.mail_activation.domain.img_path" alt="">
                  <span class="word-brake">{{ phoneActivation.mail_activation.mail }}</span>
                  <div class="--copy js-copy copy-wrapper" @click="copyText(phoneActivation.mail_activation.mail, $event)">
                    <img src="/img/svg/common/copy.svg" alt=""/>
                    <div class="custom-notification">
                      <div class="notification-title">{{getLocalization('Copied')}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="--center">
                <div :class="'--status' + (phoneActivation.mail_activation.code == null && phoneActivation.mail_activation.status.id !== STATUS_CANCEL ? '' : ' --full')">
                  <div class="--label">{{ getLocalization('Status') }}</div>
                  <div v-if="phoneActivation.mail_activation.status.id === STATUS_OK" class="--value">{{ getLocalization('SMS was received') }}</div>
                  <div class="--label" v-else>{{ getLocalization(phoneActivation.mail_activation.status.description) }}</div>
                </div>
                <div v-if="(phoneActivation.mail_activation.code == null && phoneActivation.mail_activation.status.id !== STATUS_CANCEL)" class="--time">
                  <div class="--label">{{ getLocalization('Time') }}</div>
                  <div class="--value"
                       v-if="phoneActivation.mail_activation.status.id === STATUS_WAIT_CODE">
                    <timer :target-time="phoneActivation.mail_activation.mail_available" :with-hours="false"/>
                  </div>
                </div>
                <div class="--price">
                  <div class="--label">{{ getLocalization('Price') }}</div>
                  <div class="--value">{{ phoneActivation.mail_activation.price }}₽</div>
                </div>
              </div>
            </div>
            <div class="activation-history-card__other"
                 v-if="phoneActivation.mail_activation.status.id === STATUS_WAIT_CODE || phoneActivation.mail_activation.status.id === 3">
              <div class="--codes --multi" v-if="phoneActivation.mail_activation.code?.length > 0">
                <div :data-index="index + 1" v-for="(code, index) in phoneActivation.mail_activation.code?.split(',')" :key="code">
                  <span>{{ code }}</span>
                  <div class="--copy js-copy copy-wrapper" @click="copyText(code, $event)">
                    <img src="/img/svg/common/copy.svg" alt=""/>
                    <div class="custom-notification">
                      <div class="notification-title">{{getLocalization('Copied')}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row pa-info">
                <div class="col-xl-6 col-12">
                  <div class="w-75 mt-3 right --left lift-info"></div>
                </div>
                <div class="col-xl-4 col-12 right" v-if="phoneActivation.service_variation.service.id === 5"
                     v-html="getLocalization('Telegram registration is only possible in the official mobile client on a mobile device. When registering via the web version or unofficial clients, the code will not be received')"></div>
                <div class="col-xl-4 col-12 right">
                  {{ getLocalization('We also recommend using an IP VPN or Proxy from the country you are trying to purchase from.') }}
                </div>
              </div>

            </div>
          </div>
          <div class="activation-history-card__other buy-mail-card" v-if="mailPrices[phoneActivation.service_variation.service.id]?.price">
            <div class="row pa-info">
              <button @click="buyMailPA(phoneActivation)" class="button primary">{{ getLocalization('Buy temporary Gmail for') }}
                {{ mailPrices[phoneActivation.service_variation.service.id]?.price }} &#x20bd;</button>
            </div>

          </div>
        </div>
        <green-custom-pagination v-show="this.filters[0].isActive" :per-page="perPage" :total="totalPages" :pageChanged="pageChanged">
        </green-custom-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import Vue from "vue";
import WrapperFiltersComponent from "../../../components/table/wrapperFilters.vue";
import BaseSendRequestMixin from "../../../components/mixins/BaseSendRequestMixin.vue";
import BaseMessagingMixin from "../../../components/mixins/BaseMessagingMixin.vue";
import BaseTable from "../../../components/table/baseTable.vue";
import GreenCustomPagination from "../../../components/table/pagination/greenCustomPagination.vue";
import VueSpinner from "vue-spinner/src/ClipLoader.vue";

export default {
  name: "phoneHistory",
  mixins: [
    BaseSendRequestMixin,
    BaseMessagingMixin
  ],
  components: {
    VueSpinner,
    GreenCustomPagination,
    BaseTable,
    Multiselect,
    WrapperFiltersComponent
  },
  props: [
    'phoneActivations',
    'user',
    'translations',
    'total',
    'mailHistoryRoute',
    'mailPrices'
  ],
  data: function () {
    return {
      STATUS_WAIT_CODE: 1,
      STATUS_WAIT_ACCEPTING: 2,
      STATUS_WAIT_NEXT_SMS: 3,
      STATUS_CANCEL: 8,
      STATUS_OK: 6,
      STATUS_REFUND: 10,
      responseCancelData: '',
      minutesAvailable: 1,
      filters: [
        {id: 1, label: 'Waiting for SMS only', isActive: true},
        {id: 2, label: 'Paid only', isActive: false},
        {id: 3, label: 'Canceled only', isActive: false},
        {id: 4, label: 'All phone activations', isActive: false}
      ],
      filterType: [],
      waitingForSmsCount: 0,
      waitingForCodeMails: 0,
      lockedForWaiting: 0,
      phoneActivationsData: this.phoneActivations,
      isCopied: false,
      copiedSms: [],
      allPhoneFilterActive: false,
      containerDiv: null,
      wrapperFiltersData: {
        title: this.getLocalization('Activations history'),
        filtersUrl: '/cabinet/client/phonehistory/getList',
        showResetFilterButton: true,
        showCollapseFilter: true,
        startWithRequest: true,
        newDesign: true,
        items: {
          countries: {
            enable: true,
            multiple: true,
            getDataLink: '/countries/getList',
            placeholder: this.getLocalization('Country'),
            viewLabel: 'title',
            className: '--4-12',
            needLocalization: true
          },
          services: {
            enable: true,
            multiple: true,
            getDataLink: '/services/getList',
            placeholder: this.getLocalization('Service'),
            viewLabel: 'title',
            className: '--4-12'
          },
          statuses: {
            enable: true,
            multiple: true,
            selectedKey: 'statuses',
            getDataLink: '/cabinet/client/phonehistory/getPhoneActivationStatuses',
            placeholder: this.getLocalization('Status'),
            specifyKeyForLabel: 'description',
            className: '--4-12',
            needLocalization: true
          },
          date: {
            enable: true,
            dateFromText: this.getLocalization('Date from'),
            dateToText: this.getLocalization('Date to'),
            className: 'w-100',
            circle: true
          },
        }
      },
      abortController: new AbortController,
      timeoutIds: [],
      perPage: 50,
      totalPages: this.total,
      columns: [
        {
          label: this.getLocalization('Date'),
          field: 'date',
          sortable: true,
          sortByColumn: 'date',
          width: '17%'
        },
        {
          label: this.getLocalization('Country'),
          field: 'country',
          sortable: false,
          width: '15%'
        },
        {
          label: this.getLocalization('Service'),
          sortable: false,
          field: 'service',
          width: '15%'
        },
        {
          label: this.getLocalization('Status'),
          field: 'status',
          type: 'string',
          sortByColumn: 'status',
          sortable: true,
          width: '20%'
        },
        {
          label: this.getLocalization('Number'),
          field: 'phone',
          sortable: false,
          width: '15%'
        },
        {
          label: this.getLocalization('Sms'),
          field: 'sms',
          sortable: false,
          width: '10%'
        },
        {
          label: this.getLocalization('Price'),
          field: 'price',
          width: '8%',
          sortFn: 'sortNumber',
        },
      ],
    }
  },
  beforeMount() {
    this.preparePASmsCodes(this.phoneActivationsData);
    this.containerDiv = document.getElementById('activation-history');
  },
  async mounted() {
    await this.countOverallStat();
    this.$root.$on('bought-number', async () => {
      await this.refreshBalance(null, true);
      await this.getPhoneHistory();
    });
    this.processGetStatus();
  },
  methods: {
    processGetStatus() {
      if (this.filters[0].isActive) {
        this.phoneActivationsData.forEach(item => {
          if (item.mail_activation) {
            this.sendRequestMailGetStatus(item.mail_activation)
          }
          this.sendRequestGetStatus(item)
        });
      } else if (this.filters[3].isActive) {
        this.phoneActivationsData.forEach(el => {
          let exist = [this.STATUS_WAIT_CODE, this.STATUS_WAIT_NEXT_SMS].includes(el.status.id);
          if (exist) {
            this.sendRequestGetStatus(el);
            if (el.mail_activation) {
              this.sendRequestMailGetStatus(el.mail_activation)
            }
          }
        });
      }
    },
    async sendRequestGetStatus(phoneActivation) {
      if ((phoneActivation.status.id !== this.STATUS_WAIT_CODE
          && phoneActivation.status.id !== this.STATUS_WAIT_NEXT_SMS) && !!phoneActivation.sms_given) {
        return;
      }
      let self = this;
      let timerId = setTimeout(async function request() {
        let oneMoreRequest = await self.requireOneMoreRequest(phoneActivation);
        if (!oneMoreRequest) {
          clearTimeout(timerId);
          return;
        }
        let indexToRemove = self.timeoutIds.indexOf(timerId);
        if (indexToRemove !== -1) {
          self.timeoutIds.splice(indexToRemove, 1);
        }
        timerId = setTimeout(request, 15000);
        self.timeoutIds.push(timerId);
      }, 15000);
      self.timeoutIds.push(timerId);
    },
    async sendRequestMailGetStatus(mailActivation) {
      if (mailActivation.status.id !== this.STATUS_WAIT_CODE && !!mailActivation.code) {
        return;
      }
      let self = this;
      let timerId = setTimeout(async function request() {
        let oneMoreRequest = await self.requireOneMoreMailRequest(mailActivation);
        if (!oneMoreRequest) {
          clearTimeout(timerId);
          return;
        }
        let indexToRemove = self.timeoutIds.indexOf(timerId);
        if (indexToRemove !== -1) {
          self.timeoutIds.splice(indexToRemove, 1);
        }
        timerId = setTimeout(request, 15000);
        self.timeoutIds.push(timerId);
      }, 15000);
      self.timeoutIds.push(timerId);
    },
    async requireOneMoreRequest(phoneActivation) {
      let phoneActivationForChange = this.phoneActivationsData.find(el => el.id === phoneActivation.id);
      if (!phoneActivationForChange) {
        return false;
      }
      try {
        let status = await this.getStatusByItem(phoneActivation);
        if (status === 'abortError') {
          return false;
        }
        if (status.includes('STATUS_OK:') || status.includes('STATUS_WAIT_RETRY:')) {
          let responseCode = status.split(':')[1];
          let lastCode = this.phoneActivationsData.find(pa => pa.id === phoneActivation.id).sms_code;
          if (lastCode !== null && lastCode !== undefined && !lastCode?.includes(responseCode)) {
            responseCode = lastCode + ',' + responseCode;
          } else if (lastCode !== null && lastCode !== undefined) {
            responseCode = lastCode
            phoneActivationForChange.sms_given = 1;
          }
          let statusId = this.STATUS_WAIT_ACCEPTING;
          let descriptionAlert = 'SMS was received';
          if (status.includes('STATUS_WAIT_RETRY:')) {
            statusId = this.STATUS_WAIT_NEXT_SMS;
            descriptionAlert = 'Waiting for next sms';
          }
          phoneActivationForChange.sms_code = responseCode;
          phoneActivationForChange.status.description = descriptionAlert;
          phoneActivationForChange.status.id = statusId;
        }
        if (status.includes('STATUS_CANCEL')) {
          let index = this.phoneActivationsData.findIndex(el => el.id === phoneActivation.id);
          await this.refreshBalance(index);
          if (this.filters[3].isActive) {
            let id = this.filters[3].id;
            this.phoneActivationsData = await this.sendRequest('/cabinet/client/phonehistory/getList', 'get', {id});
          } else {
            this.phoneActivationsData = this.phoneActivationsData.filter(el => el.id !== phoneActivation.id);
          }
          await this.countOverallStat();
          return false;
        }
        return (phoneActivationForChange.status.id === this.STATUS_WAIT_CODE
                || phoneActivationForChange.status.id === this.STATUS_WAIT_NEXT_SMS
                || !phoneActivationForChange.sms_given
            )
            && (this.filters[0].isActive || this.filters[3].isActive);
      } catch (e) {
        return true;
      }
    },
    async requireOneMoreMailRequest(mailActivation) {
      try {
        let item = this.phoneActivationsData.find(pa => pa.id === mailActivation.phone_activation_id);
        let status = await this.getStatusMailByItem(mailActivation);
        if (status === 'abortError') {
          return false;
        }
        if (status.status === 1 && status.code) {
          item.mail_activation.code = status.code;
          item.mail_activation.status.id = 3
          item.mail_activation.status.description = this.getLocalization('SMS was received');

        }
        return item.mail_activation.status.id === this.STATUS_WAIT_CODE
            && (this.filters[0].isActive || this.filters[3].isActive);

      } catch (e) {
        return true;
      }
    },
    async getStatusByItem(phoneActivation) {
      const data = {
        action: 'getStatus',
        id: phoneActivation.id,
      };
      return await this.sendRequest('/web/stubs/handler_api.php', 'get', data, {signal: this.abortController.signal});
    },
    async getStatusMailByItem(mailActivation) {
      const data = {
        mailId: mailActivation.id,
      };
      return await this.sendRequest('/cabinet/client/mailhistory/getCode', 'get', data, {signal: this.abortController.signal});
    },
    copyText(code, event) {
      const textToCopy = code;
      const textarea = document.createElement('textarea');
      textarea.value = textToCopy;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);

      const parentEl = event?.currentTarget;
      if (!parentEl) {
        return;
      }
      parentEl.classList.add('show');

      setTimeout(() => {
        parentEl.classList.remove('show');
      }, 2000);

      // this.isCopied = true;
      //setTimeout(() => {
      this.copiedSms = []
      //}, 2000);
    },
    async filterPhoneActivations(id) {
      this.abortAll();
      this.allPhoneFilterActive = id === 4;
      this.containerDiv.className = this.allPhoneFilterActive ? 'container --all' : 'container --waiting';
      this.filters.forEach(filter => {
        filter.isActive = (filter.id === id)
      })
      if (this.allPhoneFilterActive) {
        return;
      }
      this.phoneActivationsData = [];
      let response = await this.sendRequest('/cabinet/client/phonehistory/getList', 'get', {id});
      if (response.data) {
        this.totalPages = response.total;
        this.phoneActivationsData = response.data;
      } else {
        this.phoneActivationsData = response;
      }
      this.processGetStatus();
    },
    async getPhoneHistory() {
      this.abortAll();
      let id = 0;
      for (const key in this.filters) {
        if (this.filters[key].isActive === true) {
          id = this.filters[key].id;
        }
      }
      if (this.allPhoneFilterActive) {
        return;
      }
      let response = await this.sendRequest('/cabinet/client/phonehistory/getList', 'get', {id});
      this.totalPages = response.total;
      this.phoneActivationsData = response.data;
      await this.countOverallStat();
      this.processGetStatus();
    },
    async changePhoneActivationStatus(activationId, id, status) {
      // if (status === this.STATUS_CANCEL && this.isEarlyCancel(id)) {
      //   await this.alertMessage(this.getLocalization('It is possible to cancel the number after 2 minutes following the purchase'), 'error');
      //   return;
      // }
      this.abortAll();
      Vue.set(this.phoneActivationsData[id], 'disableCancelButton', true);
      let data = {
        action: 'setStatus',
        status: status,
        id: activationId,
      }
      let changePhoneActivationStatusRequest = await this.sendRequest('/web/stubs/handler_api.php', 'get', data);
      if (changePhoneActivationStatusRequest === 'ACCESS_CANCEL') {
        await this.alertMessage(this.getLocalization('Activation canceled'), 'good');
        this.phoneActivationsData = this.phoneActivationsData.filter(el => el.id !== activationId)
        await this.refreshBalance(id);
      } else if (changePhoneActivationStatusRequest === "EARLY_CANCEL_DENIED") {
        await this.alertMessage(this.getLocalization('It is possible to cancel the number after 2 minutes following the purchase'), 'error');
      } else if (changePhoneActivationStatusRequest === "BAD_STATUS" || status !== this.STATUS_OK) {
        await this.alertMessage(this.getLocalization('Unable to cancel now, please try again'), 'error');
      } else if (status === this.STATUS_OK) {
        await this.alertMessage(this.getLocalization('Activation completed'), 'good');
        this.phoneActivationsData = this.phoneActivationsData.filter(el => el.id !== activationId)
      } else {
        await this.alertMessage(this.getLocalization(changePhoneActivationStatusRequest), 'warn');
      }

      await new Promise(resolve => setTimeout(resolve, 1000));
      Vue.set(this.phoneActivationsData[id], 'disableCancelButton', false);
      await this.countOverallStat();
      this.processGetStatus();
    },
    async downloadCsvFile() {
      let setFilter = this.filters.filter(val => val.isActive == true)[0]['id']
      let response = await this.sendRequest('/cabinet/client/phonehistory/downloadCsvFile', 'post', {id: setFilter});
      if (response && response !== ' ') {
        this.convertResponseToDownloadFileCsv(response);
      } else {
        await this.alertMessage(
            this.getLocalization('Error. Try again'),
            'error'
        );
      }
    },
    convertResponseToDownloadFileCsv(response) {
      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');

      link.href = url;
      let date = new Date();
      let fileName = 'ActivationsHistory' + date.getHours() + '_' + date.getMinutes() + '.csv'
      link.setAttribute('download', fileName);
      document.body.appendChild(link);

      link.click();
      URL.revokeObjectURL(url);
      link.remove();
    },
    async countOverallStat() {
      let result = await this.sendRequest('/cabinet/client/phonehistory/getOverallStat');
      if (result) {
        this.lockedForWaiting = Number(result.locked_price);
        this.waitingForSmsCount = Number(result.waiting_cnt);
        this.waitingForCodeMails = Number(result.mail_waiting_cnt);
        this.refreshBadge();
      }
    },
    async requestAnotherSms(activationId, id) {
      Vue.set(this.phoneActivationsData[id], 'disableNextSmsButton', true);
      let data = {
        action: 'setStatus',
        status: this.STATUS_WAIT_NEXT_SMS,
        id: activationId,
      }
      let requestAnotherSms = await this.sendRequest('/web/stubs/handler_api.php', 'get', data);
      if (requestAnotherSms === "BAD_STATUS") {
        Vue.set(this.phoneActivationsData[id], 'response', 'Unable to get next sms now, please try again')
      } else if (requestAnotherSms === "ACCESS_RETRY_GET") {
        Vue.set(this.phoneActivationsData[id], 'response', 'Success, wait for next sms')
      }
      await new Promise(resolve => setTimeout(resolve, 2000));
      Vue.set(this.phoneActivationsData[id], 'disableNextSmsButton', false);
      await this.getPhoneHistory();
    },
    async refreshBalance(id = null, refresh = false) {
      let balance = document.querySelector(".user-balance-new");
      if (refresh) {
        let response = await this.sendRequest('/cabinet/profile/getBalance');
        if (response) {
          balance.innerHTML = response;
        }
      } else {
        let stringWithCurrency = balance.innerHTML;
        let prevBalance = stringWithCurrency.replace(/\s/g, '').replace(/[^\d.-]/g, '');
        let numberValue = parseFloat(prevBalance);
        let price = parseFloat(this.phoneActivationsData[id]?.price);
        let newBalance = numberValue + price;
        balance.innerHTML = newBalance.toLocaleString('ru-RU').replace(',', '.') + ' ₽'
      }

    },
    refreshBadge() {
      let badges = document.querySelectorAll(".badge-refresh");
      let total = this.waitingForSmsCount + this.waitingForCodeMails;
      total = total === 0 ? '' : total
      badges.forEach(el => el.innerHTML = String(total));
    },
    abortAll() {
      this.abortController.abort();
      this.timeoutIds.forEach(id => clearTimeout(id));
      this.timeoutIds = [];
      this.abortController = new AbortController;
    },
    isEarlyCancel(id) {
      return this.phoneActivationsData[id].created + 120 > Math.floor(Date.now() / 1000);
    },
    listToShow(list) {
      let data = [];
      for (let elem of list) {
        data.push({
          country: elem['service_variation']['country']['title'],
          service: elem['service_variation']['service']['title'],
          phone: elem['phone'],
          price: elem['price'],
          date: elem['created_at'],
          status: elem['status']['description'],
          sms: elem['sms_code'],
        });
      }
      this.phoneActivationsData = data;
      return data;
    },
    async pageChanged(obj) {
      this.phoneActivationsData = [];
      let result = await this.sendRequest('/cabinet/client/phonehistory/getList', 'get', {id: 1, page: obj.currentPage, perPage: obj.perPage});
      this.totalPages = result.total;
      this.phoneActivationsData = this.preparePASmsCodes(result.data);
      this.processGetStatus();
    },
    preparePASmsCodes(data) {
      return data.map(el => {
        const codes = el.phone_activation_sms
            ?.map(item => item.code)
            .filter(code => code);
        el.sms_code = codes && codes.length > 0 ? codes.join(', ') : null;
        return el;
      });
    },
    async buyMailPA(phoneActivation) {
      let domain = 'gmail.com';
      let serviceCode = phoneActivation.service_variation.service.activate_org_code;
      let data = {
        service: serviceCode,
        domain: domain,
        phone_activation_id: phoneActivation.id
      }
      let getMail = await this.sendRequest('/cabinet/client/mailhistory/getActivationPA', 'get', data);
      if (getMail.status === 1 && getMail.mail) {
        await this.alertMessage(this.getLocalization('Done. You’ve gotten an email'), 'info');
        await this.refreshBalance(null, true);
        await this.getPhoneHistory()
      } else {
        await this.alertMessage(this.getLocalization('No mail available yet'), 'error');
      }
    },
    selectMails() {
      window.location.href = this.mailHistoryRoute;
    },
    triggerBuyPhoneNumber(pa) {
      this.$root.$emit('emit-buy-phone-number', pa.price, pa.service_variation.country.activate_org_code, pa.service_variation.service.activate_org_code);
    }
  },
}
</script>
<style>
.new-design-wrapper {
  width: 100%;
}

.activation-history-all__filter .--export {
  display: flex;
}

.pagination {
  justify-content: center;
}

.pagination__items {
  display: flex;
}
.badge-pa {
  min-width: 20px;
  padding: 0 4px;
  font-size: 14px;
  top: -13px;
  right: -8px;
}
</style>
